import get from 'lodash/get';

export const resolveReadableFileSize = (size) => {
    const base = 1000;
    const metricPrefixes = ['B', 'kB', 'MB', 'GB', 'TB'];
    const prefixIndex = Math.floor(Math.log(size) / Math.log(base));
    const maximumPrefixIndex = metricPrefixes.length - 1;

    if (prefixIndex > maximumPrefixIndex) {
        const readableSize = (size / (base ** maximumPrefixIndex)).toFixed(2);
        return `${readableSize} ${get(metricPrefixes, `[${maximumPrefixIndex}]`, '')}`;
    }
    const readableSize = (size / (base ** prefixIndex)).toFixed(2);

    return `${readableSize} ${get(metricPrefixes, `[${prefixIndex}]`, '')}`;
};
